document.addEventListener("DOMContentLoaded", () => {

  const faqSections = document.querySelectorAll(".luxury-faq");

  faqSections.forEach(section => {

    const items = section.querySelectorAll(".faq-item");

    items.forEach(item => {

      const button = item.querySelector(".faq-question");
      const answer = item.querySelector(".faq-answer");

      button.setAttribute("aria-expanded", item.classList.contains("active"));

      if (item.classList.contains("active")) {
        answer.style.display = "block";
        answer.style.height = "auto";
      } else {
        answer.style.display = "none";
        answer.style.height = "0px";
      }

      button.addEventListener("click", () => {

        const isActive = item.classList.contains("active");

        items.forEach(otherItem => {

          otherItem.classList.remove("active");

          const otherButton = otherItem.querySelector(".faq-question");
          const otherAnswer = otherItem.querySelector(".faq-answer");

          otherButton.setAttribute("aria-expanded", "false");

          if (otherAnswer.style.display === "block") {

            otherAnswer.style.height = otherAnswer.scrollHeight + "px";

            requestAnimationFrame(() => {
              otherAnswer.style.height = "0px";
            });

            otherAnswer.addEventListener("transitionend", function hide() {
              if (!otherItem.classList.contains("active")) {
                otherAnswer.style.display = "none";
              }
              otherAnswer.removeEventListener("transitionend", hide);
            });

          }

        });

        if (!isActive) {

          item.classList.add("active");

          button.setAttribute("aria-expanded", "true");

          answer.style.display = "block";

          const height = answer.scrollHeight;

          answer.style.height = "0px";

          requestAnimationFrame(() => {
            answer.style.height = height + "px";
          });

          answer.addEventListener("transitionend", function finish() {
            if (item.classList.contains("active")) {
              answer.style.height = "auto";
            }
            answer.removeEventListener("transitionend", finish);
          });

        }

      });

    });

  });

});